// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button ion-icon {
  font-size: 13px;
}

.profile ion-icon {
  margin-right: 4px;
}

.ml-2 {
  margin-left: 15px;
}

ion-item {
  --min-height: 35px !important;
}

ion-avatar ion-icon {
  font-size: 40px !important;
  color: #b9b6b6;
}

ion-item ion-label {
  font-size: 12px;
  color: #6e6b7b;
}

ion-badge {
  font-size: 12px;
}

ion-item ion-label {
  margin: 4px 0px;
}

h2 {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

ion-item img {
  width: 70px;
}

.signout {
  cursor: pointer;
  color: #c72727 !important;
}

ion-list {
  padding-top: 0px;
  padding-bottom: 0px;
}

.creditDiv {
  --background: #e0e0e0;
}

.profileDiv {
  --background: #6030ff;
  --padding-start: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACQ,eAAA;AACR;;AAGA;EACI,iBAAA;AAAJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,6BAAA;AADJ;;AAIA;EACI,0BAAA;EACA,cAAA;AADJ;;AAIA;EACI,eAAA;EACA,cAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAUA;EACI,eAAA;EACA,yBAAA;AAPJ;;AAYA;EACI,gBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,qBAAA;AATJ;;AAYA;EACI,qBAAA;EACA,+BAAA;AATJ","sourcesContent":["ion-button ion-icon {\r\n        font-size: 13px;\r\n    \r\n}\r\n\r\n.profile ion-icon {\r\n    margin-right: 4px;\r\n}\r\n\r\n\r\n.ml-2 {\r\n    margin-left: 15px;\r\n}\r\n\r\nion-item {\r\n    --min-height: 35px !important;\r\n}\r\n\r\nion-avatar ion-icon {\r\n    font-size: 40px !important;\r\n    color: #b9b6b6;\r\n}\r\n\r\nion-item ion-label {\r\n    font-size: 12px;\r\n    color: #6e6b7b;\r\n}\r\n\r\nion-badge {\r\n    font-size: 12px;\r\n}\r\n\r\nion-item ion-label {\r\n    margin: 4px 0px;\r\n}\r\n\r\nh2 {\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n\r\nion-item img {\r\n    width: 70px;\r\n}\r\n\r\n// .profileIcon {\r\n//     width: 100%;\r\n//     margin: 0 auto;\r\n//     text-align: center;\r\n// }\r\n\r\n.signout {\r\n    cursor: pointer;\r\n    color: #c72727 !important;\r\n\r\n}\r\n\r\n\r\nion-list {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n\r\n.creditDiv {\r\n    --background: #e0e0e0;\r\n}\r\n\r\n.profileDiv {\r\n    --background: #6030ff;\r\n    --padding-start: 0px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
